import React from 'react'
import UserRouter from 'routes/Components/UserRouter'
import { Routes, Route } from 'react-router'

const Routers = ({ token, userData, permissions }) => {
  const isAuthenticated = Boolean(token)
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <UserRouter
            isAuthenticated={isAuthenticated}
            userData={userData}
            permissions={permissions}
          />
        }
      />
    </Routes>
  )
}

export default Routers
